// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../images/atdesk.gif", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.container {
  
}

.gJumboTron {
    padding-bottom: 20px;
    color: black;
    background: none;
    background-color: rgb(161, 184, 208);
    padding-top:30px;
    margin-top:0;
    padding-left:20px;
    border-radius:20px;
    margin-top:20px;
    -webkit-user-select: none;
            user-select: none;
    background-image:url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    color:white;
    text-shadow:0 0 8px black;
    height:540px;
    background-position:50% 55%;
    background-size:100%;
    position: relative;
}
.gJumboTron h1 {
    letter-spacing:-.04em;
}
.gJumboTron h2 {
    font-size:24px;
    padding-top:0;
    margin-top:0;
    letter-spacing:-.01em;
}

.credit {
    text-align: right;
    padding-right:20px;
    position: absolute;
    bottom:120px;
    right:10px;
    text-shadow: 0 0 18px rgb(5, 17, 85);
    font-size:16px;
    color:rgb(147, 217, 255);
    display:none;
}

@media only screen and (min-width: 800px) {
    .credit {

        display:inline-block;
    }
}`, "",{"version":3,"sources":["webpack://./src/components/Jumbotron.css"],"names":[],"mappings":"AAAA;;AAEA;;AAEA;IACI,oBAAoB;IACpB,YAAY;IACZ,gBAAgB;IAChB,oCAAoC;IACpC,gBAAgB;IAChB,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;IAClB,eAAe;IACf,yBAAiB;YAAjB,iBAAiB;IACjB,wDAA4C;IAC5C,WAAW;IACX,yBAAyB;IACzB,YAAY;IACZ,2BAA2B;IAC3B,oBAAoB;IACpB,kBAAkB;AACtB;AACA;IACI,qBAAqB;AACzB;AACA;IACI,cAAc;IACd,aAAa;IACb,YAAY;IACZ,qBAAqB;AACzB;;AAEA;IACI,iBAAiB;IACjB,kBAAkB;IAClB,kBAAkB;IAClB,YAAY;IACZ,UAAU;IACV,oCAAoC;IACpC,cAAc;IACd,wBAAwB;IACxB,YAAY;AAChB;;AAEA;IACI;;QAEI,oBAAoB;IACxB;AACJ","sourcesContent":[".container {\n  \n}\n\n.gJumboTron {\n    padding-bottom: 20px;\n    color: black;\n    background: none;\n    background-color: rgb(161, 184, 208);\n    padding-top:30px;\n    margin-top:0;\n    padding-left:20px;\n    border-radius:20px;\n    margin-top:20px;\n    user-select: none;\n    background-image:url('../images/atdesk.gif');\n    color:white;\n    text-shadow:0 0 8px black;\n    height:540px;\n    background-position:50% 55%;\n    background-size:100%;\n    position: relative;\n}\n.gJumboTron h1 {\n    letter-spacing:-.04em;\n}\n.gJumboTron h2 {\n    font-size:24px;\n    padding-top:0;\n    margin-top:0;\n    letter-spacing:-.01em;\n}\n\n.credit {\n    text-align: right;\n    padding-right:20px;\n    position: absolute;\n    bottom:120px;\n    right:10px;\n    text-shadow: 0 0 18px rgb(5, 17, 85);\n    font-size:16px;\n    color:rgb(147, 217, 255);\n    display:none;\n}\n\n@media only screen and (min-width: 800px) {\n    .credit {\n\n        display:inline-block;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
